import styles from './SproutButton.module.scss';

import cx from 'classnames';
import React, { forwardRef } from 'react';

import { ButtonProps, Button } from '@clover-web-lib-sprout/button';
import { Image } from 'components/Image/Image';

type SproutButton = ButtonProps & {
  size?: 'small';
  isTextVariant?: boolean;
};

export const SproutButton = forwardRef<HTMLButtonElement, SproutButton>(
  ({ className, variant, children, size, isTextVariant, ...props }, ref) => {
    const buttonClassName = cx(
      styles.button,
      {
        [styles.buttonPrimary]: variant === 'primary',
        [styles.buttonSecondary]: variant === 'secondary',
        [styles.small]: size === 'small',
        [styles.buttonText]: isTextVariant,
      },
      className,
    );

    return (
      <Button className={cx(buttonClassName, styles.noPadding)} variant={variant} ref={ref} {...props}>
        <div className={cx(isTextVariant && styles.buttonTextContent)}>
          {children}
          {isTextVariant && <Image className={styles.buttonTextArrow} />}
        </div>
      </Button>
    );
  },
);
